import React, { useEffect, useState, useContext, useRef } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import Web3 from "web3";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { formatDecimals, formatBalanceWithIcon, abbreviateNumber, getTokenPrice, getTokenDecimals, formatTokenIcon, formatPercentage } from '../../utils';
import { miniCardHeaderStyle, miniInfoInvertStyle, cardHeaderInvertStyle, miniCardHeaderInvertStyle, infoOutlineInvertStyle } from "./TileStyles";

import { getGradientCardStyle } from "./TileStyles";
import rocketfiIcon from "../../imgs/rocketfi_yellow_token.png";
import BigNumber from 'bignumber.js'

const DashboardInfo = ({ data, rocketFiPrice }) => {

    const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
    const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;

    const miniCardInvertStyle = (row, col) => {
        const baseStyle = {
            background: "#FFFFFF",
            borderRadius: "20px",
            color: "#333333",
            marginBottom: "10px",
            fontFamily: 'Inter, sans-serif',
            transition: '0.3s',
            gridColumn: `span ${col}`,
            gridRow: `span ${row}`,
        };
        return baseStyle;
    };

    return (
        <Card
            title={
                <div style={infoOutlineInvertStyle}>Token Info</div>
            }
            style={miniCardInvertStyle(1, 2)}
        >
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(125px, 100%), 1fr))', gap: '5px', marginTop: '10px' }}>
                
                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        {'Total Supply'
                        
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? formatBalanceWithIcon(data?.contractData?.tokenData?.rocketFiTotalSupply, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E", data?.dbData, 9)
                            : <LoadingContent />}
                    </div>
                </div>
                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        {'General Position'
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? formatPercentage(data?.contractData?.tokenData?.rocketFiBalance / data?.contractData?.tokenData?.rocketFiTotalSupply)
                            : <LoadingContent />}
                    </div>
                </div>
                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        { 'Liquidity Backing'
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? formatPercentage(data?.contractData?.tokenData?.rocketFiLiquidityBacking / 10000)
                            : <LoadingContent />}
                    </div>
                </div>

                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        {'Swap In Fee'
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? formatPercentage(data?.contractData?.tokenData?.rocketFiBuyFee / 10000)
                            : <LoadingContent />}
                    </div>
                </div>
                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        {'Swap Out Fee'
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? formatPercentage(data?.contractData?.tokenData?.rocketFiSellFee / 10000)
                            : <LoadingContent />}
                    </div>
                </div>
                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        {'Transfer Fee'
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? formatPercentage(data?.contractData?.tokenData?.rocketFiTransferFee / 10000)
                            : <LoadingContent />}
                    </div>
                </div>
                <div>
                    <div style={miniCardHeaderInvertStyle}>
                        {'Token Price (USD)'
                        }
                    </div>
                    <div style={miniInfoInvertStyle}>
                        {data?.contractData
                            ? ('$'+rocketFiPrice.toFixed(10))
                            : <LoadingContent />}
                    </div>
                </div>
            </div>


        </Card>
    );
}

export default DashboardInfo;
